/**
 * Formatea una fecha en formato ISO a un formato DD-MM-AAAA para su visualización en el sistema.
 * por defecto con el separador '-', es posible cambiar el separador indicando el nuevo caracter 
 * separador como segundo parametro.
 * 
 * @param {*} fechaISO fechaISO Fecha en formato 'YYYY-MM-DD' o ISO completo ('YYYY-MM-DDTHH:mm:ssZ')
 * @param {*} separador Separador que se quiere utilizar, por defecto es '-'.
 * @returns 01-10-2023
 * @example formatFecha('2023-10-01T00:00:00Z') => '01-10-2023'
 */
export const formatFecha = (fechaISO, separador = '-') => {
  if (!fechaISO) return '';
  const pad = (n) => n.toString().padStart(2, '0');

  // Caso 1: Solo fecha, sin hora
  if (/^\d{4}-\d{2}-\d{2}$/.test(fechaISO)) {
    const [anio, mes, dia] = fechaISO.split('-');
    return `${dia}${separador}${mes}${separador}${anio}`;
  }

  // Caso 2: Fecha con hora en formato ISO (evita desfases)
  const fecha = new Date(fechaISO);
  if (isNaN(fecha)) return '';

  const dia = pad(fecha.getUTCDate());
  const mes = pad(fecha.getUTCMonth() + 1);
  const anio = fecha.getUTCFullYear();

  return `${dia}${separador}${mes}${separador}${anio}`;
};


/**
 * Formatea la fecha para hacer el envio al backend en el formato 'AAAA-MM-DD HH:MM:SS'
 */
export const formatDateTime = (fecha) => {
  const d = new Date(fecha);
  const pad = n => n.toString().padStart(2, '0');

  const anio = d.getFullYear();
  const mes = pad(d.getMonth() + 1); // los meses van de 0 a 11
  const dia = pad(d.getDate());

  const horas = pad(d.getHours());
  const minutos = pad(d.getMinutes());
  const segundos = pad(d.getSeconds());

  return `${anio}-${mes}-${dia} ${horas}:${minutos}:${segundos}`;
}

/**
 * Formatea la fecha: 'DD-MM-AAAA HH:MM:SS'
 */
export const formatDateTimeFront = (fecha, separador = '-') => {
  const d = new Date(fecha);
  const pad = n => n.toString().padStart(2, '0');

  const anio = d.getFullYear();
  const mes = pad(d.getMonth() + 1); // los meses van de 0 a 11
  const dia = pad(d.getDate());

  const horas = pad(d.getHours());
  const minutos = pad(d.getMinutes());
  const segundos = pad(d.getSeconds());

  return `${dia}${separador}${mes}${separador}${anio} ${horas}:${minutos}:${segundos}`;
}

/**
 * Retorna la fecha en formato yyyy/mm/dd 00:00:00 (hora local)
 * @param {Date} date
 * @returns {string}
 */
export const inicioDelDia = (date) => {
  if (!(date instanceof Date)) return null;
  const pad = (n) => String(n).padStart(2, '0');
  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())} 00:00:00`;
};

/**
 * Retorna la fecha en formato yyyy/mm/dd 23:59:59 (hora local)
 * @param {Date} date
 * @returns {string}
 */
export const finDelDia = (date) => {
  if (!(date instanceof Date)) return null;
  const pad = (n) => String(n).padStart(2, '0');
  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())} 23:59:59`;
};


/**
 * Convierte una fecha en formato DD-MM-AAAA a una cadena en formato ISO.
 * @param {string} fecha Fecha en formato DD/MM/AAAA.
 * @returns {string|null} Cadena en formato ISO o null si la fecha es inválida.
 */
export const dateISOString = (fecha) => {
  if (!fecha) return null;
  const [dd, mm, yyyy] = fecha.split('-');
  return `${yyyy}-${mm}-${dd}`;
}

/**
 * Define localización en español para un calendario.
 * Incluye nombres de días, meses y otras configuraciones.
 */
export const localEs = {
  firstDayOfWeek: 1,
  dayNames: ["domingo", "lunes", "martes", "miércoles", "jueves", "viernes", "sábado"],
  dayNamesShort: ["dom", "lun", "mar", "mié", "jue", "vie", "sáb"],
  dayNamesMin: ["D", "L", "M", "X", "J", "V", "S"],
  monthNames: [
    "enero", "febrero", "marzo", "abril", "mayo", "junio",
    "julio", "agosto", "septiembre", "octubre", "noviembre", "diciembre"
  ],
  monthNamesShort: [
    "ene", "feb", "mar", "abr", "may", "jun",
    "jul", "ago", "sep", "oct", "nov", "dic"
  ],
  today: "Hoy",
  clear: "Limpiar"
};